module.exports = __webpack_public_path__ + "static/img/rpa-bg.6764edea.png";